import { render } from "./ModalTickets.vue?vue&type=template&id=4895ce73&scoped=true&ts=true"
import script from "./ModalTickets.vue?vue&type=script&lang=ts"
export * from "./ModalTickets.vue?vue&type=script&lang=ts"

import "./ModalTickets.vue?vue&type=style&index=0&id=4895ce73&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4895ce73"]])

export default __exports__